import React from 'react';
import { connect } from 'react-redux';
import { saveStates } from '@/constants/lifecycle';
import findResult from '@/utils/resultsHelper';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { newDatasourceSettings } from '../datasource/state/state';
import { toggleDatasetWizard } from '../actions';
import { resolveCatalogueTemplate } from '../catalogue/helper';
import { datasetSourceAndStepAttributes } from '../state/state';
import { disableDatasetWizardView } from '../status/helper';
import { datasetSettingsFields } from '../settings/state/state';

const DatasetWizardAction = ({
  category,
  code,
  disabled,
  template,
  toggleWizard,
  wizardOn,
}) => (
  <RibbonMenu
    name="view"
    icon={wizardOn ? 'pencil' : 'magic'}
    message={wizardOn ? 'actions.advanced' : 'actions.wizard'}
    onClick={() => toggleWizard(category, code, template)}
    className="aridhia-dataset-wizard-action"
    disabled={disabled}
  />
);

const mapStateToProps = ({
  catalogues: { templates },
  datasets: { datasets },
  datasetDatasource: { settings },
}, ownProps) => {
  const datasourceSettings = findResult(settings, ownProps.category, ownProps.code) || newDatasourceSettings(ownProps);
  const { dataset, template } = resolveCatalogueTemplate(datasets, templates, ownProps, {
    settings: datasetSettingsFields(),
    steps: datasetSourceAndStepAttributes(),
    ...saveStates,
  });

  return {
    disabled: disableDatasetWizardView(dataset, template, datasourceSettings),
    template,
    wizardOn: dataset.steps.wizardOn,
  };
};

const mapDispatchToProps = {
  toggleWizard: toggleDatasetWizard,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetWizardAction);
